const MyEmrysCoins = () => {
    return (
        <div>
            <h1>My EmrysCoins</h1>
        </div>
    );
};

export default MyEmrysCoins;
